export default __webpack_public_path__ + "static/media/irisity-logo-animation.1ea791a9.mp4";